import Vue from 'vue';

Vue.filter('humanumber', (value) => {
  const formatter = Intl.NumberFormat('ru-RU');
  return formatter.format(value);
});
